<template>
	<IntersectionChild @enter="onEnter">
		<div id="new-msg-divider" />
	</IntersectionChild>
</template>

<script>
import { IntersectionChild } from '@/components/common/Intersection'

export default {
	name: 'UnreadDivider',
	components: { IntersectionChild },
	methods: {
		onEnter() {
			this.$emit('viewed', true)
		},
	},
	emits: ['viewed']
}
</script>

<style lang="scss" scoped>
#new-msg-divider {
	height: 1px;
	opacity: 0;
	width: 100%;
}
</style>
